<template>
  <section class="section">
    <div class="container">
      <h1 class="title">{{ $translate('allestimenti') | capitalize }}</h1>
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <b-button
              v-if="permissions.canCreate"
              type="is-primary"
              icon-right="plus"
              @click="
                $router.push({
                  name: 'newAllestimento',
                  params: { id: -1, module: module },
                })
              "
            ></b-button>
          </div>
        </div>
        <div class="level-right"></div>
      </div>
      <b-table
        :data="filteredData"
        :paginated="tableOptions.isPaginated"
        :narrowed="true"
        :per-page="tableOptions.perPage"
        :current-page.sync="tableOptions.currentPage"
        :pagination-simple="tableOptions.isPaginationSimple"
        :sort-icon="tableOptions.sortIcon"
        :sort-icon-size="tableOptions.sortIconSize"
        :loading="tableOptions.loading"
        hoverable
        :scrollable="true"
      >
        <template slot-scope="props">
          <b-table-column field="name" :label="$translate('name') | capitalize">
            {{ props.row.name ? props.row.name : '-' }}
          </b-table-column>

          <b-table-column field="description" :label="$translate('pellami') | capitalize">
            <b-button @click="showPelModal(props.row.Pel_M)" class="is-primary">
              <b-icon @click="showPelModal(props.row.Pel_M)" icon="format-list-checkbox"></b-icon>
            </b-button>
          </b-table-column>

          <b-table-column field="type" :label="$translate('riporti') | capitalize">
            <b-button @click="showRipModal(props.row.Rip_M)" class="is-primary">
              <b-icon icon="format-list-checkbox"></b-icon>
            </b-button>
          </b-table-column>

          <b-table-column :label="$translate('action') | capitalize">
            <a
              @click="
                $router.push({
                  name: 'editAllestimento',
                  params: { id: props.row.id, module: module },
                })
              "
            >
              <b-icon icon="pencil-outline"></b-icon>
            </a>
            <!--            <a @click="askForShapes(props.row.id)">-->
            <!--              <b-icon icon="format-list-checkbox"></b-icon>-->
            <!--            </a>-->
            <a
              v-if="permissions.canCreate"
              @click="
                $router.push({
                  name: 'editAllestimento',
                  params: { idtocopy: props.row.id, module: module },
                })
              "
            >
              <b-icon icon="content-copy"></b-icon>
            </a>
            <a v-if="permissions.canDelete" @click="deleteOccurence(props.row.id)">
              <b-icon icon="delete-outline"></b-icon>
            </a>
          </b-table-column>
        </template>
      </b-table>
    </div>
    <b-modal :active.sync="isModalActive" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div class="modal-card" style="width: auto;">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('materials') | capitalize }}
          </p>
        </header>
        <section class="modal-card-body">
          <ul>
            <li v-for="mat in modalList" :key="mat.id">{{ mat.commercial_name }} - {{ mat.CUI }}</li>
          </ul>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="isModalActive = false">
            {{ $translate('close') | capitalize }}
          </button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import mainMixin from '@/helpers/mixins/mainMixin'
import permissionMixin from '@/helpers/mixins/permissionMixin'
import materialTools from '../../helpers/mixins/materialTools'

export default {
  name: 'Allestimenti',
  components: {},
  mixins: [mainMixin, permissionMixin, materialTools],
  props: ['module'],
  data() {
    return {
      loading: true,
      isModalActive: false,
      modalList: [],
      availablepell: [],
      availablerip: [],
    }
  },
  async mounted() {
    let permissionDenied = true
    switch (this.userInfo.type) {
      case 'A':
        permissionDenied = false
        this.permissions.canCreate = true
        this.permissions.canEdit = true
        this.permissions.canHide = true
        this.permissions.canDelete = true
        break
      case 'I':
        if (this.userInfo.level === 'S' || this.userInfo.level === '2') {
          this.permissions.canCreate = true
          this.permissions.canEdit = true
          this.permissions.canDelete = true
        }
        permissionDenied = false
        break
    }
    if (permissionDenied) this.$router.push('/forbidden')
    this.availablepell = await this.getMaterialArray('Pel_M')
    this.availablerip = await this.getMaterialArray('Rip_M')
    await this.loadData()
    this.tableOptions.loading = false
  },
  methods: {
    deleteOccurence(idtoerase) {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('allestimento_message_destroy'),
        cancelText: this.$translate('undo'),
        confirmText: this.$translate('allestimento_message_confirm'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$db
            .collection('allestimenti')
            .doc(idtoerase)
            .delete()
            .then(async () => {
              await this.loadData()
              this.$buefy.notification.open({
                duration: 3000,
                message: this.$translate('success_delete'),
              })
            })
        },
      })
    },
    async loadData() {
      let newTableData = []
      this.$db
        .collection('allestimenti')
        .orderBy('name', 'asc')
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            let allestimento = doc.data()
            allestimento.id = doc.id
            newTableData.push(allestimento)
          })
          this.filteredData = newTableData
          this.tableOptions.loading = false
        })
    },
    showPelModal(matList) {
      const matToShow = this.availablepell.filter(m => matList.includes(m.id))
      this.isModalActive = true
      this.modalList = matToShow
    },
    showRipModal(matList) {
      const matToShow = this.availablerip.filter(m => matList.includes(m.id))
      this.isModalActive = true
      this.modalList = matToShow
    },
  },
}
</script>

<style scoped>
.modal-card {
  min-width: 400px;
}
</style>
